import { Resources } from "@/types/subject-schema";
import { ThemeIcon } from "@mantine/core";
import { getRawIconForResource } from "lib/utils/icons";

export default function ResourceIcon({
  resource,
  size = 75,
  backgroundColor = "lightblue",
  className = "resourceIcon",
}: {
  resource: Resources;
  backgroundColor?: string;
  size?: number;
  className?: string;
}) {
  const Icon = getRawIconForResource(resource);
  return (
    <ThemeIcon
      className={className}
      size={size}
      radius="md"
      color={backgroundColor}
      variant="filled"
      style={{ transition: "all 250ms ease", overflow: "hidden" }}
    >
      <Icon width={"100%"} height={"100%"} />
      {/* SVG designed to fill the icon */}
    </ThemeIcon>
  );
}
